module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/banner_white_ant.400d2f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc/product/banner_white_ant.jpg
// module id = vVkR
// module chunks = 0